<template>
  <div id="creditManagement">
    <div class="box news-box">
      <div class="sub-nav">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>信用管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="new-wrapper">
        <div class="left-box fl" style="    padding-bottom: 25px;">
          <div class="left-box-title">
            <img src="../../assets/images/notice-icon.png" style="top: 14px" alt />
            失信黑名单
            <img src="../../assets/images/right.png" alt />
          </div>
          <div class="left-box-content">
            <img style="    width: 100%;" src="../../assets/xygl.png" alt />
          </div>
        </div>
        <div class="right-box fr">
          <div style="margin-bottom:50px">
            <el-table :data="tableData" style="width: 100%" @row-click="rowClick">
              <el-table-column align="center" prop="unitName" label="单位名称"></el-table-column>
              <el-table-column align="center" prop="creditCode" label="信用代码"></el-table-column>
            </el-table>
          </div>
          <div class="page">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page.current"
              :page-sizes="[10, 20, 50, 100,500]"
              :page-size="page.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.total"
              background
            ></el-pagination>
          </div>
        </div>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
import { getcreditDataPage } from "../../api/index";
export default {
  name: "",
  data() {
    return {
      query: {
        current: 1,
        size: 10,
        title: ""
      },
      fullHeight: document.documentElement.clientHeight,
      page: {
        total: 0
      },
      tableData: []
    };
  },
  created() {
    this.getData();
  },
  methods: {
    rowClick(row, column, event){
      console.log(row, column, event);
      this.handelTurnDetail(row)

    },
    getData() {
      getcreditDataPage(this.query).then(res => {
        this.tableData = res.data.records;
        this.page.total = res.data.total || 0;
      });
    },
    handleSizeChange(val) {
      this.$set(this.query, "size", val);
      this.getData();
    },
    handleCurrentChange(val) {
      this.$set(this.query, "current", val);
      this.getData();
    },
    handelTurnDetail(row) {
      this.$router.push({
        path: "/creditManagementDetail/" + row.id
      });
    }
  }
};
</script>

<style lang="" >
#creditManagement .el-table th {
  background: rgba(1,173,214,1);
  color: #fff;
}
#creditManagement .el-table--enable-row-transition .el-table__body td{
      border: 1px solid #fff;
}
#creditManagement .el-table tr{
    background: rgba(1,173,214,0.06);
}
</style>


// WEBPACK FOOTER //
// src/views/creditManagement/index.vue